import cookies from "./cookies";

const agentInfo = cookies.getAgentInfo();

const payTypes = [
  {
    name: '到店支付',
    type: 3,
  }
];

let stripe = {
  name: 'Stripe支付',
  type: 1,
};

let paypal = {
  name: 'PayPal',
  type: 2,
};

let payMe = {
  name: 'PayMe',
  type: 5,
};

let fps = {
  name: 'Fps',
  type: 6
}

if (agentInfo.isPaypal === '1'){
  payTypes.push(paypal);
}

if (agentInfo.isPayme === '1') {
  payTypes.push(payMe);
}

if (agentInfo.isStripe === '1') {
  payTypes.push(stripe);
}

if (agentInfo.isFps === '1') {
  payTypes.push(fps)
}



export default payTypes;
